////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
import convertHexToRGBA from '../../../helpers/HexToRgba'

//////STYLED//////
const SalesHistoryStatusWrapper = styled.div`
	text-align: center;
	background-color: ${(props) => convertHexToRGBA(props.colorCode, 0.2)};
	color: ${(props) => props.colorCode};
	line-height: 32px;
	font-weight: bold;
	width: fit-content;
	padding: 0 10px;
	border-radius: 15px;
	margin: 0 auto;
	font-weight: bold;
`
//////STYLED//////

const SalesHistoryStatus = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<SalesHistoryStatusWrapper colorCode={props.row.transactionState.colorCode}>
			{translations[props.row.transactionState.translationKey]}
		</SalesHistoryStatusWrapper>
	)
}

SalesHistoryStatus.propTypes = {}

SalesHistoryStatus.defaultPropTypes = {}

export default SalesHistoryStatus
